import { mainApiAxios as axios } from '@/plugins/axios'


export default {

    listData() {
        return axios.get('Municipalitiesdata')
    },

    updateData(dataId, dataObj) {
        return axios.post(`Municipalitiesdata/edit/${dataId}`, dataObj)
    },

    addData(dataObj) {
        return axios.post('Municipalitiesdata', dataObj)
    },

    deleteData(dataId) {
        return axios.post(`Municipalitiesdata/delete/${dataId}`)
    }
}